module.exports = __webpack_public_path__ + "static/media/colicoli1.93223571.webp";